// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-message-view {
  position: relative;
  width: 100%;
}
.user-message-view__sticky-container {
  background-color: var(--primary-color-light-500);
  border-radius: 1rem;
  padding: 1.5rem 1rem;
  width: 100%;
  transition: padding 0.3s ease, border-radius 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
  display: grid !important;
  grid-template-rows: 2.5rem 1fr;
  grid-gap: 0.5rem;
  gap: 0.5rem;
  z-index: var(--z-index-sticky);
  will-change: transform, height;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;
  contain: layout style;
  overflow: visible;
}
.user-message-view__sticky-container .user-message-actions {
  display: none;
}
.user-message-view__sticky-container.has-no-scrollable-area, .user-message-view__sticky-container.is-sticky {
  grid-template-rows: auto 1fr;
  grid-template-columns: 32px 5fr;
}
@media screen and (max-width: 992px) {
  .user-message-view__sticky-container.has-no-scrollable-area, .user-message-view__sticky-container.is-sticky {
    grid-template-columns: 32px 5fr 200px;
  }
}
.user-message-view__sticky-container.has-no-scrollable-area .user-message-actions, .user-message-view__sticky-container.is-sticky .user-message-actions {
  display: grid;
  height: auto;
  min-height: 28px;
  max-height: 66px;
  transition: height 0.2s ease 0.3s;
  grid-row: 2;
  grid-column-start: 1;
  grid-column-end: 4;
}
@media screen and (max-width: 1152px) {
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-actions, .user-message-view__sticky-container.is-sticky .user-message-actions {
    max-height: 76px;
  }
}
@media screen and (max-width: 1024px) {
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-actions, .user-message-view__sticky-container.is-sticky .user-message-actions {
    max-height: 76px;
  }
}
@media screen and (max-width: 768px) {
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-actions, .user-message-view__sticky-container.is-sticky .user-message-actions {
    max-height: 76px;
  }
}
@media screen and (max-width: 480px) {
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-actions, .user-message-view__sticky-container.is-sticky .user-message-actions {
    max-height: 98px;
  }
}
@media screen and (max-width: 992px) {
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-actions .user-message-actions > .ui-button[data-testid=sources-button]:first-child[data-tooltip]:not([data-tooltip=""]):after, .user-message-view__sticky-container.is-sticky .user-message-actions .user-message-actions > .ui-button[data-testid=sources-button]:first-child[data-tooltip]:not([data-tooltip=""]):after {
    left: 0px !important;
    transform: none !important;
  }
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-actions .user-message-actions > .ui-button[data-testid=sources-button]:first-child[data-tooltip]:not([data-tooltip=""]):before, .user-message-view__sticky-container.is-sticky .user-message-actions .user-message-actions > .ui-button[data-testid=sources-button]:first-child[data-tooltip]:not([data-tooltip=""]):before {
    left: 20px !important;
    transform: none !important;
  }
}
.user-message-view__sticky-container.has-no-scrollable-area .user-message-view__followup-questions.open, .user-message-view__sticky-container.is-sticky .user-message-view__followup-questions.open {
  display: flex;
  height: auto;
  max-height: 50vh;
  transition: height 0.3s ease 0.2s;
  grid-column-start: 1;
  grid-column-end: 4;
  overflow-y: auto;
}
.user-message-view__sticky-container.has-no-scrollable-area .user-message-view__sources.open, .user-message-view__sticky-container.is-sticky .user-message-view__sources.open {
  display: flex;
  height: auto;
  max-height: 50vh;
  transition: height 0.3s ease 0.2s;
  overflow-y: auto;
  grid-column-start: 1;
  grid-column-end: 4;
}
.user-message-view__sticky-container.has-no-scrollable-area .user-message-view__profile, .user-message-view__sticky-container.is-sticky .user-message-view__profile {
  padding-bottom: 0.75rem;
  grid-template-columns: 1fr;
  gap: 0;
  max-height: 32px;
  transition: all 0.3s ease;
}
.user-message-view__sticky-container.has-no-scrollable-area .user-message-view__user-info, .user-message-view__sticky-container.is-sticky .user-message-view__user-info {
  display: none;
}
.user-message-view__sticky-container.has-no-scrollable-area .user-message-view__avatar, .user-message-view__sticky-container.is-sticky .user-message-view__avatar {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  grid-row: 1;
  transition: all 0.3s ease;
  flex-shrink: 0;
}
.user-message-view__sticky-container.has-no-scrollable-area .user-message-view__question, .user-message-view__sticky-container.is-sticky .user-message-view__question {
  grid-row: 1;
}
@media screen and (max-height: 662px), screen and (max-width: 992px) {
  .user-message-view__sticky-container.has-no-scrollable-area, .user-message-view__sticky-container.is-sticky {
    padding: 0.75rem 0.75rem;
    grid-template-rows: auto auto;
    grid-template-columns: 32px minmax(0, 1fr);
    column-gap: 6px;
    row-gap: 8px;
    color: var(--primary-color-500);
    border-radius: 1.25rem;
    align-items: center;
    transition: padding 0.3s ease, border-radius 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
  }
  .user-message-view__sticky-container.has-no-scrollable-area:before, .user-message-view__sticky-container.is-sticky:before {
    display: none;
  }
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-view__profile, .user-message-view__sticky-container.is-sticky .user-message-view__profile {
    grid-row: 1;
    grid-column: 1;
    padding-bottom: 0;
    max-height: 32px;
    transition: all 0.3s ease;
  }
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-view__question, .user-message-view__sticky-container.is-sticky .user-message-view__question {
    grid-row: 1;
    grid-column: 2;
  }
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-actions, .user-message-view__sticky-container.is-sticky .user-message-actions {
    grid-row: 2;
    grid-column: 1/-1;
    justify-content: flex-start;
    padding-left: 40px;
  }
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-view__followup-questions, .user-message-view__sticky-container.is-sticky .user-message-view__followup-questions {
    display: none;
  }
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-view__followup-questions.open, .user-message-view__sticky-container.is-sticky .user-message-view__followup-questions.open {
    display: flex;
    height: auto;
    max-height: 50vh;
    grid-column: 1/-1;
    grid-row: 3;
    transition: height 0.3s ease 0.2s;
    overflow-y: auto;
    margin-top: 5px;
  }
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-view__sources, .user-message-view__sticky-container.is-sticky .user-message-view__sources {
    display: none;
  }
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-view__sources.open, .user-message-view__sticky-container.is-sticky .user-message-view__sources.open {
    display: flex;
    height: auto;
    max-height: 50vh;
    grid-column: 1/-1;
    grid-row: 3;
    transition: height 0.3s ease 0.2s;
    overflow-y: auto;
    margin-top: 5px;
  }
  .user-message-view__sticky-container.has-no-scrollable-area .user-message-view__sources.open .sources-view, .user-message-view__sticky-container.is-sticky .user-message-view__sources.open .sources-view {
    width: 100%;
  }
}
.user-message-view__sticky-container.is-sticky {
  position: fixed;
  top: 20px;
  top: var(--scroll-container-top, 20px);
  box-shadow: 0 2px 10px 5px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 0.5rem 1rem;
  background-color: var(--primary-color-light-500);
  z-index: var(--z-index-sticky);
}
.user-message-view__sticky-container.is-sticky .user-message-view__question-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.user-message-view__profile {
  display: grid !important;
  grid-template-columns: 2.5rem 10fr;
  align-items: center;
  grid-gap: 0.5rem;
  gap: 0.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-border);
  grid-row: 1;
}
.user-message-view__avatar {
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
  grid-row: 1;
  transition: all 0.3s ease;
  flex-shrink: 0;
}
@media screen and (max-width: 426px) {
  .user-message-view__avatar {
    width: 2rem;
    min-width: 2rem;
    height: 2rem;
  }
}
.user-message-view__user-info {
  display: flex;
  flex-direction: column;
  grid-row: 1;
}
.user-message-view__name {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
}
.user-message-view__title {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  margin: 0.25rem 0 0;
}
.user-message-view__question {
  grid-row: 2;
  align-self: center;
}
.user-message-view__followup-questions {
  display: none;
  gap: 10px;
  height: 0px;
  transition: height 0.3s ease 0.2s;
  overflow: hidden;
  justify-content: start;
}
.user-message-view__followup-questions:before {
  display: none;
}
.user-message-view__sources {
  display: none;
  gap: 10px;
  height: 0px;
  transition: height 0.3s ease 0.2s;
  overflow: hidden;
  justify-content: start;
}
.user-message-view__sources:before {
  display: none;
}
.user-message-view__sources.open .sources-view {
  width: 100%;
}
.user-message-view__question-text {
  font-size: 1rem;
  line-height: 1.5;
  color: var(--color-text-primary);
  margin: 0;
  word-break: break-word;
  white-space: pre-wrap;
}
@media screen and (min-width: 768px) {
  .user-message-view__sticky-container {
    padding: 1.5rem 1rem;
  }
  .user-message-view__name {
    font-size: 1.25rem;
  }
  .user-message-view__question-text {
    font-size: 1.125rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/UserMessageView/UserMessageView.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;AACF;AACE;EACE,gDAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,wGAAA;EACA,wBAAA;EACA,8BAAA;EACA,gBAAA;EAAA,WAAA;EACA,8BAAA;EAGA,8BAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mCAAA;EAIA,qBAAA;EACA,iBAAA;AAJJ;AAMI;EACE,aAAA;AAJN;AAOI;EA6FE,4BAAA;EACA,+BAAA;AAjGN;AAKM;EAFF;IAGI,qCAAA;EAFN;AACF;AAIM;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;AAFR;AAIQ;EAVF;IAWI,gBAAA;EADR;AACF;AAGQ;EAdF;IAeI,gBAAA;EAAR;AACF;AAGQ;EAnBF;IAoBI,gBAAA;EAAR;AACF;AAEQ;EAvBF;IAwBI,gBAAA;EACR;AACF;AAGU;EACE;IACE,oBAAA;IACA,0BAAA;EADZ;EAGU;IACE,qBAAA;IACA,0BAAA;EADZ;AACF;AAMM;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAJR;AAOM;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AALR;AAQM;EACE,uBAAA;EACA,0BAAA;EACA,MAAA;EACA,gBAAA;EACA,yBAAA;AANR;AASM;EACE,aAAA;AAPR;AAUM;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AARR;AAWM;EACE,WAAA;AATR;AAeM;EAhGF;IAsGI,wBAAA;IAEA,6BAAA;IACA,0CAAA;IACA,eAAA;IACA,YAAA;IACA,+BAAA;IACA,sBAAA;IACA,mBAAA;IACA,wGAAA;EAlBN;EAKM;IACE,aAAA;EAHR;EAiBM;IACE,WAAA;IACA,cAAA;IACA,iBAAA;IACA,gBAAA;IACA,yBAAA;EAfR;EAkBM;IACE,WAAA;IACA,cAAA;EAhBR;EAmBM;IACE,WAAA;IACA,iBAAA;IACA,2BAAA;IACA,kBAAA;EAjBR;EAoBM;IACE,aAAA;EAlBR;EAoBQ;IACE,aAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;IACA,iCAAA;IACA,gBAAA;IACA,eAAA;EAlBV;EAsBM;IACE,aAAA;EApBR;EAqBQ;IACE,aAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;IACA,iCAAA;IACA,gBAAA;IACA,eAAA;EAnBV;EAqBU;IACE,WAAA;EAnBZ;AACF;AAyBI;EACE,eAAA;EACA,SAAA;EAAA,sCAAA;EACA,iFAAA;EACA,oBAAA;EACA,gDAAA;EACA,8BAAA;AAvBN;AA4BM;EACE,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1BR;AA+BE;EACE,wBAAA;EACA,kCAAA;EACA,mBAAA;EACA,gBAAA;EAAA,WAAA;EACA,oBAAA;EACA,4CAAA;EACA,WAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AA9BJ;AAiCI;EAXF;IAYI,WAAA;IACA,eAAA;IACA,YAAA;EA9BJ;AACF;AAiCE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AA/BJ;AAkCE;EACE,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,SAAA;AAhCJ;AAmCE;EACE,mBAAA;EACA,kCAAA;EACA,mBAAA;AAjCJ;AAoCE;EACE,WAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,iCAAA;EACA,gBAAA;EACA,sBAAA;AAnCJ;AAqCI;EACE,aAAA;AAnCN;AAuCE;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,iCAAA;EACA,gBAAA;EACA,sBAAA;AArCJ;AAuCI;EACE,aAAA;AArCN;AAyCM;EACE,WAAA;AAvCR;AA4CE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,SAAA;EACA,sBAAA;EACA,qBAAA;AA1CJ;AA6CE;EACE;IACE,oBAAA;EA3CJ;EA8CE;IACE,kBAAA;EA5CJ;EA+CE;IACE,mBAAA;EA7CJ;AACF","sourcesContent":[".user-message-view {\n  position: relative;\n  width: 100%;\n  \n  &__sticky-container {\n    background-color: var(--primary-color-light-500);\n    border-radius: 1rem;\n    padding: 1.5rem 1rem;\n    width: 100%;\n    transition: padding 0.3s ease, border-radius 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;\n    display: grid !important;\n    grid-template-rows: 2.5rem 1fr;\n    gap: 0.5rem;\n    z-index: var(--z-index-sticky);\n    \n    // Performance and stability optimizations\n    will-change: transform, height;\n    backface-visibility: hidden;\n    -webkit-font-smoothing: antialiased;\n    \n    // Allow dropdown menus to escape the container\n    // contain: layout style keeps layout containment but allows paint to escape\n    contain: layout style;\n    overflow: visible;\n    \n    .user-message-actions { \n      display: none;\n    }\n\n    &.has-no-scrollable-area, &.is-sticky {\n\n      @media screen and (max-width: 992px) {\n        grid-template-columns: 32px 5fr 200px;\n      }\n      \n      .user-message-actions {\n        display: grid;\n        height: auto;\n        min-height: 28px;\n        max-height: 66px;\n        transition: height 0.2s ease 0.3s;\n        grid-row: 2;\n        grid-column-start: 1;\n        grid-column-end: 4;\n\n        @media screen and (max-width: 1152px) {\n          max-height: 76px;\n        }\n\n        @media screen and (max-width: 1024px) {\n          max-height: 76px;\n        }\n\n        \n        @media screen and (max-width: 768px) {\n          max-height: 76px;\n        }\n\n        @media screen and (max-width: 480px) {\n          max-height: 98px;\n        }\n\n        // Mobile sticky header: keep Share tooltip centered; shift only Sources tooltip right when it's on the left edge\n        .user-message-actions > .ui-button[data-testid=\"sources-button\"]:first-child[data-tooltip]:not([data-tooltip=\"\"]) {\n          @media screen and (max-width: 992px) {\n            &:after {\n              left: 0px !important;\n              transform: none !important;\n            }\n            &:before {\n              left: 20px !important;\n              transform: none !important;\n            }\n          }\n        }\n      }\n\n      .user-message-view__followup-questions.open {\n        display: flex;\n        height: auto;\n        max-height: 50vh; // Prevent excessive height\n        transition: height 0.3s ease 0.2s;\n        grid-column-start: 1;\n        grid-column-end: 4;\n        overflow-y: auto;\n      }\n\n      .user-message-view__sources.open {\n        display: flex;\n        height: auto;\n        max-height: 50vh;\n        transition: height 0.3s ease 0.2s;\n        overflow-y: auto;\n        grid-column-start: 1;\n        grid-column-end: 4;\n      }\n\n      .user-message-view__profile {\n        padding-bottom: 0.75rem;\n        grid-template-columns: 1fr;\n        gap: 0;\n        max-height: 32px;\n        transition: all 0.3s ease;\n      }\n\n      .user-message-view__user-info {\n        display: none;\n      }\n\n      .user-message-view__avatar {\n        width: 2rem;\n        min-width: 2rem;\n        height: 2rem;\n        grid-row: 1;\n        transition: all 0.3s ease;\n        flex-shrink: 0;\n      }\n\n      .user-message-view__question {\n        grid-row: 1;\n      }\n\n      grid-template-rows: auto 1fr;\n      grid-template-columns: 32px 5fr;\n\n      @media screen and (max-height: 662px), screen and (max-width: 992px) {\n\n        &:before {\n          display: none;\n        }\n\n        padding: 0.75rem 0.75rem;\n        // Mobile: 2-row layout - buttons below question\n        grid-template-rows: auto auto;\n        grid-template-columns: 32px minmax(0, 1fr);\n        column-gap: 6px;\n        row-gap: 8px;\n        color: var(--primary-color-500);\n        border-radius: 1.25rem;\n        align-items: center;\n        transition: padding 0.3s ease, border-radius 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;\n\n        .user-message-view__profile {\n          grid-row: 1;\n          grid-column: 1;\n          padding-bottom: 0;\n          max-height: 32px;\n          transition: all 0.3s ease;\n        }\n\n        .user-message-view__question {\n          grid-row: 1;\n          grid-column: 2;\n        }\n\n        .user-message-actions {\n          grid-row: 2;\n          grid-column: 1 / -1; // Full width\n          justify-content: flex-start;\n          padding-left: 40px; // Align with question text (32px avatar + 8px gap)\n        }\n\n        .user-message-view__followup-questions {\n          display: none;\n\n          &.open {\n            display: flex;\n            height: auto;\n            max-height: 50vh;\n            grid-column: 1 / -1;\n            grid-row: 3;\n            transition: height 0.3s ease 0.2s;\n            overflow-y: auto;\n            margin-top: 5px;\n          }\n        }\n\n        .user-message-view__sources {\n          display: none;\n          &.open {\n            display: flex;\n            height: auto;\n            max-height: 50vh;\n            grid-column: 1 / -1;\n            grid-row: 3;\n            transition: height 0.3s ease 0.2s;\n            overflow-y: auto;\n            margin-top: 5px;\n\n            .sources-view {\n              width: 100%;\n            }\n          }\n        }\n      }\n    }\n\n    &.is-sticky {\n      position: fixed;\n      top: var(--scroll-container-top, 20px);\n      box-shadow: 0 2px 10px 5px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n      padding: 0.5rem 1rem;\n      background-color: var(--primary-color-light-500);\n      z-index: var(--z-index-sticky);\n\n      // Positioning (left/width) is now handled by .perplexity-layout .is-sticky in PerplexitySidebar.scss\n      // to ensure perfect alignment with sidebar and form paddings.\n      \n      .user-message-view__question-text {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: normal;\n      }\n    }\n  }\n\n  &__profile {\n    display: grid !important;\n    grid-template-columns: 2.5rem 10fr;\n    align-items: center;\n    gap: 0.5rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid var(--color-border);\n    grid-row: 1;\n  }\n\n  &__avatar {\n    width: 2.5rem;\n    min-width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 50%;\n    object-fit: cover;\n    grid-row: 1;\n    transition: all 0.3s ease;\n    flex-shrink: 0;\n\n    // Smaller avatar on very small screens to prevent clipping\n    @media screen and (max-width: 426px) {\n      width: 2rem;\n      min-width: 2rem;\n      height: 2rem;\n    }\n  }\n\n  &__user-info {\n    display: flex;\n    flex-direction: column;\n    grid-row: 1;\n  }\n\n  &__name {\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: var(--color-text-primary);\n    margin: 0;\n  }\n\n  &__title {\n    font-size: 0.875rem;\n    color: var(--color-text-secondary);\n    margin: 0.25rem 0 0;\n  }\n\n  &__question {\n    grid-row: 2;\n    align-self: center;\n  }\n\n  &__followup-questions {\n    display: none;\n    gap: 10px;\n    height: 0px;\n    transition: height 0.3s ease 0.2s;\n    overflow: hidden;\n    justify-content: start;\n    \n    &:before {\n      display: none;\n    }\n  }\n\n  &__sources {\n    display: none;\n    gap: 10px;\n    height: 0px;\n    transition: height 0.3s ease 0.2s;\n    overflow: hidden;\n    justify-content: start;\n\n    &:before {\n      display: none;\n    }\n\n    &.open {\n      .sources-view {\n        width: 100%;\n      }\n    }\n  }\n\n  &__question-text {\n    font-size: 1rem;\n    line-height: 1.5;\n    color: var(--color-text-primary);\n    margin: 0;\n    word-break: break-word;\n    white-space: pre-wrap;\n  }\n\n  @media screen and (min-width: 768px) {\n    &__sticky-container {\n      padding: 1.5rem 1rem;\n    }\n\n    &__name {\n      font-size: 1.25rem;\n    }\n\n    &__question-text {\n      font-size: 1.125rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
